import MediaUtils from "@/utils/MediaUtils";
import i18n from './i18n';

export default class uploadZs {
    static levelFilter(val) {
        const levelList = {
            32701: "积木初级组",
            32702: "积木中级组",
            32703: "积木高级组",
            32711: "Python中级组",
            32712: "Python高级组",
        };
        return levelList[val];
    }

    static genderList() {
        return [
            { id: 1, name: "男" },
            { id: 2, name: "女" },
        ];
    }

    static gradeList() {
        return [
            { id: 0, name: i18n.t("Kindergarten") },
            { id: 1, name: i18n.t("Grade 1" ) },
            { id: 2, name: i18n.t("Grade 2" ) },
            { id: 3, name: i18n.t("Grade 3" ) },
            { id: 4, name: i18n.t("Grade 4" ) },
            { id: 5, name: i18n.t("Grade 5" ) },
            { id: 6, name: i18n.t("Grade 6" ) },
            { id: 7, name: i18n.t("Grade 7" ) },
            { id: 8, name: i18n.t("Grade 8" ) },
            { id: 9, name: i18n.t("Grade 9" ) },
            { id: 10, name: i18n.t("Grade 10" ) },
            { id: 11, name: i18n.t("Grade 11")  },
            { id: 12, name: i18n.t("Grade 12")  },
            { id: 13, name: i18n.t("Grade 13+")  },
        ];
    }

    static ageList() {
        return [
            { id: 6, name: i18n.t("less than 7 yrs") },
            { id: 7, name: i18n.t("{years} yrs", {years: 7})},
            { id: 8, name: i18n.t("{years} yrs", {years: 8}) },
            { id: 9, name: i18n.t("{years} yrs", {years: 9}) },
            { id: 10, name: i18n.t("{years} yrs", {years: 10}) },
            { id: 11, name: i18n.t("{years} yrs", {years: 11}) },
            { id: 12, name: i18n.t("{years} yrs", {years: 12}) },
            { id: 13, name: i18n.t("{years} yrs", {years: 13}) },
            { id: 14, name: i18n.t("{years} yrs", {years: 14}) },
            { id: 15, name: i18n.t("{years} yrs", {years: 15}) },
            { id: 16, name: i18n.t("{years} yrs", {years: 16}) },
            { id: 17, name: i18n.t("{years} yrs", {years: 17})  },
            { id: 18, name: i18n.t("{years} yrs", {years: 18})  },
            { id: 19, name: i18n.t("18+ yrs")  },
        ];
    }

    static gradeFilter(status) {
        const statusMap = {
            0: this.$t("Kindergarten"),
            1: this.$t("Grade 1"),
            2: this.$t("Grade 2"),
            3: this.$t("Grade 3"),
            4: this.$t("Grade 4"),
            5: this.$t("Grade 5"),
            6: this.$t("Grade 6"),
            7: this.$t("Grade 7"),
            8: this.$t("Grade 8"),
            9: this.$t("Grade 9"),
            10: this.$t("Grade 10"),
            11: this.$t("Grade 11"),
            12: this.$t("Grade 12"),
            13: this.$t("Grade 13+"),
        };
        return statusMap[status];
    }

    setup(url, arr) {
        url = "v1000001.png";
        arr = [{
                text: "你好世界世界",
                width: "Wcenter",
                height: 2203,
            },
            {
                text: "10000100DCA1111",
                width: 1140,
                height: 2403,
            },
            {
                text: "金奖",
                width: 1140,
                height: 2533,
            },
        ];
        let cat = new PIXI.Sprite(
            PIXI.loader.resources[
                MediaUtils.getStaticDomain() + "assets/zone/" + url
            ].texture
        );
        this.apps.stage.addChild(cat);
        let style = new PIXI.TextStyle({
            fontFamily: "Arial",
            fontSize: 100,
            fill: "white",
            stroke: "#ff3300",
            strokeThickness: 4,
            dropShadow: true,
            dropShadowColor: "#000000",
            dropShadowBlur: 4,
            dropShadowAngle: Math.PI / 6,
            dropShadowDistance: 6,
        });
        arr.forEach((e) => {
            let message = new PIXI.Text(e.text, style);
            if (e.width == "Wcenter") e.width = (2481 - message.width) / 2;
            message.position.set(e.width, e.height);
            this.apps.stage.addChild(message);
        });
    }

    /**
     * @desc 函数防抖
     * @param func 函数
     * @param wait 延迟执行毫秒数
     * @param immediate true 表立即执行，false 表非立即执行
     */
    debounce = (func, wait, immediate) => {
        let timeout;
        return function() {
            let context = this;
            let args = arguments;
            if (timeout) clearTimeout(timeout);
            if (immediate) {
                let callNow = !timeout;
                timeout = setTimeout(() => {
                    timeout = null;
                }, wait);
                if (callNow) func.apply(context, args);
            } else {
                timeout = setTimeout(function() {
                    func.apply(context, args);
                }, wait);
            }
        };
    };
}


// WEBPACK FOOTER //
// ./src/utils/common.js